import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AuthenticationService } from 'clan-auth';
import { RoleType } from 'models';
import { UserService } from '../../../../core/services/user.service';
import { FormControl } from '@angular/forms';
import Role from '../../../../core/models/Role';
import { VERSION } from '../../../../../assets/version';
import { Subscription, zip, combineLatest } from 'rxjs';
import { GlobalEventsService } from 'src/app/services/global/global-events-service';
import { CustomConfigurationService } from 'src/app/core/services/custom-configuration.service';

@Component({
    selector: 'app-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['./navigation-menu.component.scss'],
    animations: [
        trigger('openCloseNav', [
            state(
                'openNav',
                style({
                    maxHeight: '325px',
                    overflow: 'hidden',
                })
            ),
            state(
                'closedNav',
                style({
                    height: '56px',
                    overflow: 'hidden',
                })
            ),
            transition('openNav => closedNav', [animate('0.5s')]),
            transition('closedNav => openNav', [animate('0.5s')]),
        ]),
    ],
})
export class NavigationMenuComponent implements OnInit {
    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.screenWidth = window.innerWidth;
        if (this.screenWidth < 1350) {
            this.isOpen = false;
            this.closeMenus();
            this.navigationToggle.emit(this.isOpen);
        } else {
            this.isOpen = true;
            this.reopenMenus();
            this.navigationToggle.emit(this.isOpen);
        }
    }
    @Output() navigationToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

    screenWidth;
    isSmallNavigationMenu = false;
    isOpen = true;
    isSimulationsOpen = false;
    isAKAccountOpen = false;
    isPensionFundOpen = false;
    trinities: Role[] = null;
    companyNameMap: Map<string, string>;
    companyForm = new FormControl();
    version;
    isNotPensioner: boolean = false;
    isEmployer: boolean = false;
    hasWEF: boolean = true;
    hasCMS: boolean = false;
    hasNews: boolean = false;
    belowPensionAge: boolean = true;
    public logoUrl = '';
    public showAK = false;
    public showCabinet = false;
    private subscription: Subscription = new Subscription();

    reopenSimulations = false;
    reopenAKAccount = false;
    reopenPensionFund = false;

    constructor(
        private user: UserService,
        private auth: AuthenticationService,
        private globalEventsService: GlobalEventsService,
        private customConfigurationService: CustomConfigurationService
    ) {
        this.version = VERSION;
        this.subscription.add(
            this.globalEventsService.logo.subscribe((logo) => {
                this.logoUrl = logo;
            })
        );
        this.subscription.add(
            this.user.hasAK$.subscribe((hasAk) => {
                this.showAK = hasAk;
            })
        );

        this.subscription.add(
            combineLatest([
                this.globalEventsService.hasCabinet,
                this.customConfigurationService.isInPilotGroup$
            ]).subscribe(([hasCabinet, isInPilotGroup]) => {
                this.showCabinet = hasCabinet || isInPilotGroup;
            })
        );
    }

    ngOnInit() {
        this.screenWidth = window.innerWidth;
        if (window.innerWidth < 700) {
            this.isOpen = false;
        }

        this.user.$allCompanies.subscribe({
            next: (trinities) => {
                this.trinities = trinities;
                this.companyForm.setValue(this.trinities);
            },
        });
        this.user.$companyNameMap.subscribe({
            next: (map) => (this.companyNameMap = map),
        });
        if (this.auth.isValid()) {
            this.user.getData();
            this.checkWef();
            this.checkIfBelowPensionAge();
            this.user.isNotPensioner$.subscribe((isNotPensioner: boolean) => {
                this.isNotPensioner = isNotPensioner;
            });
            this.user.isEmployer$.subscribe((isEmployer: boolean) => {
                this.isEmployer = isEmployer;
            });
        }
    }

    checkIfBelowPensionAge() {
        this.user.$clanMyData.subscribe(myData => {

            if (myData && myData.insurances && myData.insurances.length > 0) {
                const insurance = myData.insurances[0];

                let ordinaryPensionAgeDate = null;

                if (insurance?.ordinaryPensionAgeDate) {
                    ordinaryPensionAgeDate = insurance?.ordinaryPensionAgeDate;
                }
                if (ordinaryPensionAgeDate) {
                    const retirementDate = new Date(ordinaryPensionAgeDate);
                    const currentDate = new Date();
                    // If current date is before retirement date, the person is below pension age
                    this.belowPensionAge = currentDate < retirementDate;
                } else {
                    this.belowPensionAge = true;
                }
            } else {
                console.log('No insurance data found');
                this.belowPensionAge = true;
            }
        });
    }

    saveOpenMenus() {
        if (this.isSimulationsOpen) {
            this.reopenSimulations = true;
        }
        if (this.isAKAccountOpen) {
            this.reopenAKAccount = true;
        }
        if (this.isPensionFundOpen) {
            this.reopenPensionFund = true;
        }
    }

    reopenMenus() {
        console.warn('reopen');
        if (this.reopenSimulations) {
            this.isSimulationsOpen = true;
            this.reopenSimulations = false;
        }
        if (this.reopenAKAccount) {
            this.isAKAccountOpen = true;
            this.reopenAKAccount = false;
        }
        if (this.reopenPensionFund) {
            this.isPensionFundOpen = true;
            this.reopenPensionFund = false;
        }
    }

    closeMenus() {
        this.saveOpenMenus();
        if (this.isSimulationsOpen) this.simulationsMenuClick();
        if (this.isAKAccountOpen) this.akAccountMenuClick();
        if (this.isPensionFundOpen) this.pensionFundClick();
    }

    menuOpen() {
        this.isOpen ? this.closeMenus() : this.reopenMenus();
        this.isOpen = !this.isOpen;
        this.navigationToggle.emit(this.isOpen);
    }
    simulationsMenuClick() {
        this.isSimulationsOpen = !this.isSimulationsOpen;
    }
    akAccountMenuClick() {
        this.isAKAccountOpen = !this.isAKAccountOpen;
    }
    pensionFundClick() {
        this.isPensionFundOpen = !this.isPensionFundOpen;
    }
    changeCompany(event) {
        if (event.isUserInput) {
            if (event.source.selected) {
                this.user.addSelectedCompany(event.source.value);
            } else {
                this.user.removeSelectedCompany(event.source.value);
            }
        }
    }

    checkWef() {
        zip(
            this.customConfigurationService.getCustomConfiguration$('companyConfig'),
            this.user.$currentPerson
        ).subscribe(([config, person]) => {
            const company = person.roles.find(
                (role) => role.roleType === RoleType.EMPLOYEE || role.roleType === RoleType.PENSIONER
            ).companyId;
            const customFeatures = config?.config[company]?.employee?.features;
            this.hasWEF = customFeatures?.wef === false ? false : true;
            sessionStorage.setItem('hasWEF', this.hasWEF.toString());
            const cms = customFeatures?.contentManagment;
            this.hasCMS = cms;
            this.customConfigurationService.setCMS(this.hasCMS);
            let news = customFeatures?.news;
            this.hasNews = news;
            this.customConfigurationService.setNews(news);
            const pilotGroup: string[] = config?.config[company]?.employee?.pilotGroup;
            if (pilotGroup) {
                const isInPilotGroup = pilotGroup.includes(person.personalInformation.addresses[0].email);
                this.customConfigurationService.setInPilotGroup(isInPilotGroup);
            } else {
                this.customConfigurationService.setInPilotGroup(false);
            }
        });
    }
}
